export const modes = {
  TABLEVIEW: 0,
  DETAILVIEW:  1,
  EDITVIEW: 2
};

